// extracted by mini-css-extract-plugin
module.exports = {"Picture":"Picture__2S5BO","Picture_asset":"Picture_asset__2S5BO","Picture___cover":"Picture___cover__2S5BO","Picture___contain":"Picture___contain__2S5BO"};